import { Box, chakra, shouldForwardProp } from '@chakra-ui/react';
import { isValidMotionProp, motion, useWillChange } from 'framer-motion';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Link } from 'react-router-dom';

import PrevButton from '@/components/Modal/PrevButton';

import CommonModal from '../../components/Common/CommonModal';
import { COMMON_WEB_PATH } from '../../constant';
import useCheckLogin from '../../hook/useCheckLogin';
import { usePreviousPagePath } from '../../hook/usePreviousPagePath';
import { resetInvalidAuth } from '../../redux/action/member/memberAction';
import SignupForm from './signupForm';

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop)
});

const Signup = () => {
  const { t } = useTranslation();
  const i18n_header = (key) => t(`header.${key}`);
  const i18n_backend_response = (key) => t(`backend_response.${key}`);

  const navigate = useNavigate();
  const previousPage = usePreviousPagePath();

  const dispatch = useDispatch();

  const willChange = useWillChange();

  const { isLogin } = useCheckLogin();

  useEffect(() => {
    dispatch(resetInvalidAuth());

    if (isLogin) {
      navigate('/');
    }
  }, []);

  return (
    <ChakraBox
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      style={{ willChange }}
      display="flex"
      flexDirection={`column`}
      justifyContent={`start`}
      alignItems="center"
      zIndex="10000"
      py="10vh"
      px="10px"
      width={{
        base: '100%'
      }}
      height={{
        base: '100%'
      }}
      overflowY={`scroll`}
      position="fixed"
      top={`0px`}
      left={`0px`}
      className={`no-scrollbar backdrop-blur-md lg:backdrop-blur-none`}
    >
      <CommonModal bgNone title={i18n_header('signup')}>
        <Box px="common-x">
          <Box
            width="100%"
            px="common-x"
            py="10px"
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
            className="no-scrollbar"
          >
            <SignupForm />
          </Box>
        </Box>
      </CommonModal>
    </ChakraBox>
  );
};

export default Signup;
